import React from 'react';
import PropTypes from 'prop-types';
import ItemsActions from '../itemsActions';
import { ItemCard } from '../../components/ReturnItem';
import { Language, rawString } from '../Language';
import generateMethodKey from '../../lib/generateMethodKey';
import { isNotShipped } from '../PendingReturns/utils';
import { RETURN_STATUS } from '../../constants/labels';
import { store } from '../../store';

const getInitiatedReturnsHeader = ({ label }) =>
  isNotShipped({ label })
    ? [
        `returns.step_1.initiated_returns_header.${label.return_status}`,
        `returns.step_1.initiated_returns_header.${generateMethodKey(label)}`,
        'returns.step_1.initiated_returns_header',
      ]
    : 'returns.step_1.scanned_returns_header';

export const InitiatedReturn = ({
  s,
  label,
  openCancelModal,
  cancelLabel,
  showButtonReprintLabel,
  isNotEmptyLabel,
}) => {
  const {
    page: { productType } = {},
    returnsSettings: { [productType]: { showInitiatedReturnsTrackingNumber = false } = {} } = {},
  } = store.getState();

  if (!isNotEmptyLabel(label)) {
    return null;
  }

  const replacementTokens = {
    returnMethod: label.return_method,
    rmaNumber: label.rma_number,
    trackingNumber: label.tracking_number,
    carrierMoniker: label.carrier_moniker,
    trackingUrl: label.tracking_url,
    trackingStatus: label.tracking_status,
    returnStatus: label.return_status,
    numberOfItems: label.number_of_items,
    carrier: label.carrier,
  };

  return (
    <>
      <Language
        className={`initiated-returns-header ${s.label_header}`}
        tagName="h4"
        langKey={getInitiatedReturnsHeader({ label })}
        replacementTokens={replacementTokens}
      />
      {showInitiatedReturnsTrackingNumber && (
        <Language
          tagName="div"
          className={`initiated-returns-tracking-number ${s.initiated_tracking_number}`}
          content={`${rawString({ langKey: 'returns.step_1.initiated_returns_tracking_number_label' })} ${label.tracking_number}`}
        />
      )}

      <items-actions>
        <ItemsActions
          {...{
            label,
            openCancelModal,
            cancelLabel,
            showButtonReprintLabel,
          }}
        />
      </items-actions>

      <div>
        {label.return_items.map((e, itemIndex) => (
          <return-item data-test={`return-item-init-${itemIndex}`} key={e.item_id || e.id}>
            <ItemCard
              data-test="item-card-init"
              {...{
                className: 'return-item-container return-initiated-item',
                itemQty: 'qty',
                item: e,
                itemIndex,
              }}
            />
          </return-item>
        ))}
      </div>
    </>
  );
};

InitiatedReturn.propTypes = {
  s: PropTypes.shape({
    label_header: PropTypes.string,
    initiated_tracking_number: PropTypes.string,
  }).isRequired,
  label: PropTypes.shape({
    return_method: PropTypes.string,
    return_id: PropTypes.number.isRequired,
    encrypted_return_id: PropTypes.string,
    rma_number: PropTypes.string,
    tracking_number: PropTypes.string,
    carrier_moniker: PropTypes.string,
    tracking_url: PropTypes.string,
    tracking_status: PropTypes.string,
    return_status: PropTypes.oneOf(Object.values(RETURN_STATUS)).isRequired,
    cancel_eligibility: PropTypes.bool,
    qr_code: PropTypes.bool,
    created_date: PropTypes.string,
    number_of_items: PropTypes.number.isRequired,
    pssl: PropTypes.bool,
    carrier: PropTypes.string,
    return_items: PropTypes.arrayOf(
      PropTypes.shape({
        qty: PropTypes.number.isRequired,
      }),
    ).isRequired,
  }).isRequired,
  openCancelModal: PropTypes.func.isRequired,
  cancelLabel: PropTypes.func.isRequired,
  showButtonReprintLabel: PropTypes.func.isRequired,
  isNotEmptyLabel: PropTypes.func.isRequired,
};
